// material ui
import { CircularProgress } from "@mui/material";

type CircularSpinnerProps = {
    loading: boolean,
    variant: string,
    color?: "primary" | "secondary";
}

const CircularSpinner = ({ loading, variant, color = "primary" }: CircularSpinnerProps) => {
    if (!loading) return null

    let size = 40 // default
    if (variant === "medium") {
        size = 26
    }
    if (variant === "iconButton") {
        size = 20
    }
    if (variant === "small") {
        size = 12
    }
    if (variant === "text") {
        size = 15
    }

    return (
        <CircularProgress size={size} color={color} />
    )
}

export default CircularSpinner;
